import { ProCard, ProDescriptions } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { addressDescriptionItem } from '@app/icare/components/entity/EntityDescriptionItems'
import { MedicalSpecialityEnum } from '@app/icare/entities/clinic/schema/Clinic'
import { ClinicEditDrawer } from '@app/icare/routes/_app/kliniken/-components/ClinicEditDrawer'
import { t } from '@lingui/core/macro'
import { EditSectionButton } from '@pkg/ui/button'
import { TypedDescriptionsItem } from '@pkg/ui/proValueTypes'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Flex } from 'antd'

export const Route = createFileRoute('/_app/kliniken/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  const clinic = data

  return (
    <Flex vertical gap="small">
      <ProCard
        headerBordered
        title={t`Allgemein`}
        extra={<EditSectionButton onClick={() => void ClinicEditDrawer.show({ id: clinic.id, section: 'basic' })} />}
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Spezialisierung`}>
            {clinic.speciality ? MedicalSpecialityEnum.$.getLabel(clinic.speciality) : undefined}
          </TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Name`}>{clinic.name}</TypedDescriptionsItem>
          <TypedDescriptionsItem label={t`Extra`}>{clinic.addition}</TypedDescriptionsItem>
          {addressDescriptionItem(clinic.address)}
        </ProDescriptions>
      </ProCard>
      <ProCard
        headerBordered
        title={t`Sonstiges`}
        extra={<EditSectionButton onClick={() => void ClinicEditDrawer.show({ id: clinic.id, section: 'misc' })} />}
      >
        <ProDescriptions column={1} size="small" colon={false}>
          <TypedDescriptionsItem label={t`Bemerkungen`}>{clinic.comment}</TypedDescriptionsItem>
        </ProDescriptions>
      </ProCard>
    </Flex>
  )
}
